module.exports = __webpack_public_path__ + "ae4fff99be8524ce3a43463bb96e5afd.png";